<template>
  <div
    :class="$style.wrapper"
    @click="$emit('click')"
  >
    <transition
      v-if="$slots.overlay"
      name="fade"
      @enter="$emit('onOverlayEnter')"
      @leave="$emit('onOverlayHide')"
    >
      <div
        v-show="isHover"
        :class="$style.hoverOverlayWrapper"
      >
        <slot name="overlay" />
      </div>
    </transition>
    <b-img-lazy
      v-if="isLazy && url"
      :blank-src="require('@/assets/images/spinner.svg')"
      :style="sizeClass"
      :src="url"
      :fluid-grow="autoSize"
      :class="[
        $style.avatar,
        ...className
      ]"
    />
    <b-img
      v-else-if="url"
      :fluid-grow="autoSize"
      :style="sizeClass"
      :src="url"
      :class="[
        $style.avatar,
        ...className
      ]"
    />
    <b-img
      v-else
      :fluid-grow="autoSize"
      :src="defaultAvatar"
      :style="sizeClass"
      :class="[
        $style.avatar,
        ...className
      ]"
    />
  </div>
</template>

<script>
export default {
  name: 'BaseAvatar',
  inheritAttrs: false,
  props: {
    size: {
      type: Number,
      required: false,
      default: 50,
    },
    autoSize: {
      type: Boolean,
      required: false,
      default: false,
    },
    url: {
      type: String,
      required: false,
      default: null,
    },
    className: {
      type: String,
      required: false,
      default: null,
    },
    isLazy: {
      type: Boolean,
      required: false,
      default: false,
    },
    isHover: {
      type: Boolean,
      required: false,
      default: false,
    },
    maxWidthViewWidth: {
      type: Number,
      required: false,
      default: 100,
    },
  },
  data() {
    return {
      defaultAvatar: require('@/assets/images/avatar.svg'),
    }
  },
  computed: {
    sizeClass() {
      if (this.autoSize) {
        return {}
      }
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
        maxWidth: `${this.maxWidthViewWidth}vw`,
      }
    },
  },
}
</script>

<style module lang="scss">
  @import "../../assets/scss/variables";
  .wrapper {
    position: relative;
    display: inline-block;
    .avatar {
      border-radius: 50%;
    }
    .hoverOverlayWrapper {
      position: absolute;
      background-color: rgba(0, 0, 0, 0.2);
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      color: $color-white;
      cursor: pointer;
      top: 0;
      div {
        border-radius: 50%;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
        display: flex;
      }
    }
  }
</style>
